import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormControl, UntypedFormControl } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { UsersService } from 'src/app/services/users.service';
import { WhatsappcontactService } from 'src/app/services/whatsappcontact.service';

@Component({
  selector: 'calsoft-whats-app-assigne-user',
  templateUrl: './whats-app-assigne-user.component.html',
  styleUrls: ['./whats-app-assigne-user.component.scss']
})
export class WhatsAppAssigneUserComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';


  read: any = false;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  priceGroupList: any;
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'id' + "," + Constant.Dsc;
  filterActive: boolean = false;
  pageIndex: any;
  pageSize: number;
  pageList: any;
  id: any;
  spinner: boolean;

  firstFormGroup: UntypedFormGroup;
  todayDate: Date = new Date();
  text: string;
  title: string;
  operationType: string;
  textAccount: string;
  paginationDetail = new BehaviorSubject({
    length: 10,
    pageIndex: 0,
    pageSize: 10
  });
  pageSizeValue: any;
  search: any;

  elements: any;
  rowgap: string;
  rowLeft: string;
  rowRight: string;
  selectedIndex: any;
  rowData: any;
  ownerId: any;
  ownerIds: any = [];
  name: any;
  type: any;
  service: any;
  typeData: any = 1;

  contactid: any;
  assignedUsersId: any;
  constructor(
    public router: Router,
    private _formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private whatsappcontactService: WhatsappcontactService,
    private usersService: UsersService,
    private ecryptService: EcryptServiceService,
    public datepipe: DatePipe,
    private dialogRef: MatDialogRef<WhatsAppAssigneUserComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data,


  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });
    this.contactid = data?.contactUid ?? data;
    this.assignedUsersId = data?.assignedUsersId ?? null;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngOnInit(): void {
    this.read = true;
    this.rowLeft = "100";
    this.rowgap = "0px"
    this.text = 'Save';
    this.initWhatsAppForm();
    this.getUserDropDownList();
    this.usertypeYFilter();
    this.getCrmData();


  }
  initWhatsAppForm() {
    this.firstFormGroup = this._formBuilder.group({
      id: [''],
      contactUid: [this.contactid],
      status: [''],
      updatedAt: [''],
      createdAt: [''],
      firstName: [''],
      lastName: [''],
      countriesId: [''],
      whatsappOptOut: [''],
      phoneVerifiedAt: [''],
      email: [''],
      emailVerifiedAt: [''],
      vendorId: [''],
      waId: [''],
      languageCode: [''],
      disableAiBot: [''],
      data: [''],
      assignedUsersId: [this.assignedUsersId],
      isDeleted: [''],
    });
  }

  close() {
    this.dialogRef.close({ event: 'close' })
  }


  AssignUsers() {
    if (this.text == 'Save' && this.firstFormGroup.valid) {
      this.text = "Processing"
      this.whatsappcontactService.uploadWhatsAppAssignedUser(this.firstFormGroup.value).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            this.dialogRef.close({ event: 'add' })
          }
          else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { });
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }


  //user Group

  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();

  defaultLeadOwner: FormControl = new FormControl('');

  protected _onDestroy = new Subject<void>();

  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;

  getUserDropDownList() {

    this.usersService.getAllUserStatusDropDown().subscribe(
      res => {
        this.userList = res;
        this.userTypeList = res;
        this.filtereduserTypeList = this.userTypeList;
      },
      error => {
      })
  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }

  data: any;

  vendorId: any;


  getCrmData() {
    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        localStorage.setItem("value", JSON.stringify(data))
        this.data = data;

        console.log("crmsetting", this.data);


        this.vendorId = this.data['whatsappVendorId'];


      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
